import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxProtocolType } from "../protocol.type";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

const END_OF_LINE = "\r\n";

@Pipe({
  name: "jsonMessage",
  standalone: false,
})
export class JSONMessagePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string, protocol: any): string {
    // logger.out.info(value);
    let translatedString: string = "";
    if (value === undefined) return translatedString;

    if (protocol === BfxProtocolType.ORDER) {
      let message: [{}] = JSON.parse(value);
      message.forEach((element) => {
        if (typeof element["id"] === "string" && element["id"].length > 0) {
          try {
            translatedString +=
              this.translateService.instant(element["id"], element["args"]) + END_OF_LINE;
          } catch (ex) {
            logger.out.error(
              `ERROR: JSONMessagePipe(ORDER): element: ${element} | exception: ${ex}`,
            );
            translatedString += element["id"] + END_OF_LINE;
          }
        }
      });
      return translatedString;
    } else if (protocol === BfxProtocolType.RFQ) {
      let message: {} = JSON.parse(value);
      try {
        return this.translateService.instant(message["messageId"], message["params"]);
      } catch (ex) {
        logger.out.error(`ERROR: JSONMessagePipe(RFQ): element: ${message} | exception: ${ex}`);
        return message["messageId"];
      }
    }
    return translatedString;
  }
}
